<template>
  <v-app class="view">
    <div :style="{
                        paddingLeft:(8)+'px',
                        paddingRight:(8)+'px',

                     }"
         class="list-header">
      <v-row
          class="list-header-row">


        <v-col class="text-right  d-none d-md-inline">

          <a :href="'/api/reports/pending_order?token='+$helper.access_token()"
             target="_blank">สรุปรายงาน</a> &nbsp;
        </v-col>
      </v-row>
    </div>



    <v-content>

      <v-container
          class="fill-height container"
          fluid
      >

        <OrderRowInPending
            v-for="(order, index) in items"
            :order="order"
            :key="index"
            :currentIndex="-padItemOffset+startElementIndex+index-padItemAmount"
            :style="{top:((-padItemOffset+startElementIndex+index-padItemAmount)*itemHeight)+'px'}"

        >

        </OrderRowInPending>


        <LoadingDummy
            :store="store"
            :itemHeight="itemHeight"
            :scrollY="scrollY"
            :maxElementRender="maxElementRender">
        </LoadingDummy>

        <div class="dummy"
             :style="{top:(store.data?(store.data.length*itemHeight+40):40)+'px'}">

        </div>

      </v-container>
    </v-content>


<!--    <div class="summary">-->
<!--      <span v-if="store.summary['commission_value']">-->
<!--        ยอดคอมฯ {{$helper.number_format(store.summary['commission_value'],2,2)}} บาท-->
<!--      </span>-->
<!--      ยอด SO {{$helper.number_format(store.summary['total_gross'],2,2)}} บาท-->

<!--    </div>-->
  </v-app>
</template>
<style lang="scss" scoped>
  .dummy {
    position: absolute;
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .summary {
    position: fixed;
    bottom: 0;
    display: block;
    height: 40px;
    width: 100%;
    text-align: right;
    padding: 8px;
  }

  .theme--light .summary {
    background: #FFFFFF;
  }

  .theme--dark .summary {
    background: #000000;
  }

  .view {
    font-size: 18px;
  }

  .nav {
    z-index: 1;
  }

  .container {
    position: relative;
    margin-top: 80px;
    /*margin-bottom: 40px;*/
    /*min-width: 750px;*/
  }

  @media (max-height: 700px) {

  }

  .pad-filter {
    padding: 16px 0 0 24px;
  }

  .search .v-input__control {
    /*height: 60px;*/
  }

  .list-header {
    position: fixed;
    top: 60px;
    z-index: 1;
    width: 100%;

  }

  .theme--light .list-header-row {
    background: #FFFFFF;
  }

  .theme--dark .list-header-row {
    background: #000000;
  }

  .status-btn {
    font-weight: bold;
    font-size: 20px;
    min-width: 36px !important;
    padding: 2px 4px 4px !important;
    margin-right: 4px;
  }

</style>
<script lang="ts">
  import OrderRowInPending from '@/components/Order/OrderRowInPending.vue'
  import {Component, Prop} from 'vue-property-decorator'
  import FilterButton from '../components/FilterButton.vue'
  import LoadingDummy from '../components/LoadingDummy.vue'
  import {Order, OrderConst} from '../models/Order'
  import {UserConst} from '../models/User'
  import Helper from '../services/Helper.js'
  import ListView from './ListView'

  @Component({
    components: {OrderRowInPending, LoadingDummy, FilterButton},
  })
  export default class ViewOrderPending extends ListView<Order> {
    @Prop() noSearch: boolean


    OrderConst = OrderConst
    isPickingDate = false


    store = this.$store.state.orders_pending

    drawer_ratio = 0.2

    commit_prefix = 'orders_pending'
    base_url = Helper.setting.order.getListAPI

    isForceReload = true

    dateFrom = ''
    dateTo = ''

    skip_first_fetch=true

    mounted() {
      // let tmpDateFrom = new Date()
      // tmpDateFrom.setDate(tmpDateFrom.getDate() - 7)
      // this.dateFrom = tmpDateFrom.toISOString().substr(0, 10)

      this.dateFrom = '';
      this.dateTo = '';
      if (this.$route.params.status) {
        this.setFilter('status', this.$route.params.status)
      }

      this.setFilter('pending', '1')


    }


    onListLoaded(data) {
      if (this.$route.params.id) {
        console.log('onListLoaded', data)
        let index: number = -1

        for (let i in data.data) {
          const order: Order = data.data[i]
          if (order.id == parseInt(this.$route.params.id)) {
            index = parseInt(i)
          }
        }


        if (index >= 0) {
          this.$store.commit('dialog_is_order', {toggle: true, index: index})
        }
      }
      return
    }


    get isApproveComOptionAble() {
      switch (this.$store.state.$user.role) {
        case UserConst.ROLE_ADMIN:
          return true
        case UserConst.ROLE_CEO:
          return true
        case UserConst.ROLE_DIRECTOR:
          return true
        default:
          return false
      }


    }


  }
</script>
<style lang="scss" scoped>
  .view {

    .fill-height {
      /*padding-left: 150px;*/
    }
  }

  .nav {
    position: fixed;
    margin-top: 60px;

  }
</style>
